import { useMutation } from '@tanstack/react-query'

import { useAlertContext } from '@/contexts/AlertContext'
import { releaseResource, steerResource } from '@/features/flexBalance/endpoints/flexbalance'
import { SteeringCommand } from '@/features/flexBalance/types'

export function useFlexBalanceSteeringMutation() {
  const { pushAlert } = useAlertContext()
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (variables: { steeringCommand: SteeringCommand; continuousSteering: boolean }) => {
      if (variables.steeringCommand === SteeringCommand.STEER) {
        return steerResource(variables.continuousSteering)
      } else {
        return releaseResource()
      }
    },
    onSuccess: async (_, variables: { steeringCommand: SteeringCommand; continuousSteering: boolean }) => {
      pushAlert({
        severity: 'success',
        message:
          variables.steeringCommand === SteeringCommand.RELEASE
            ? 'The resource release process has started'
            : 'Resource steering has started',
      })
    },
    onError: () => {
      pushAlert({
        severity: 'error',
        message: 'An error has occurred',
      })
    },
  })

  return {
    steerResource: mutateAsync,
    ...mutationResult,
  }
}
